<script lang="ts">
  import { needsExplanation } from '$lib/utils/happyCode';
  let { installation = $bindable(0), recommendation = $bindable(0), timeliness = $bindable(0), comment = $bindable('') } = $props<{ installation?: number; recommendation?: number; timeliness?: number; comment?: string }>();
  const negative = $derived(needsExplanation({ installation_score: installation, recommendation_score: recommendation, timeliness_score: timeliness || undefined, comment }));
  const questions = [
    { text: 'How satisfied are you with the installation?', low: 'Not satisfied', high: 'Very satisfied' },
    { text: 'Would you recommend Toyama to a friend?', low: 'Not likely', high: 'Very likely' },
    { text: 'Was the team on time and tidy?', low: 'Not at all', high: 'Completely' },
  ];
</script>
<div class="scores">
  {#each questions as question, i}
    <fieldset>
      <legend>{question.text}{i === 2 ? ' (optional)' : ' *'}</legend>
      <div class="scale">
        {#each [1, 2, 3, 4, 5] as score}
          <label class:negative={score <= 2}>
            {#if i === 0}<input type="radio" name="installation" value={score} bind:group={installation} required />
            {:else if i === 1}<input type="radio" name="recommendation" value={score} bind:group={recommendation} required />
            {:else}<input type="radio" name="timeliness" value={score} bind:group={timeliness} />{/if}
            <span>{score}</span>
          </label>
        {/each}
      </div>
      <div class="anchors"><span>{question.low}</span><span>{question.high}</span></div>
      {#if i === 2 && timeliness}<button type="button" onclick={() => timeliness = 0}>Clear optional answer</button>{/if}
    </fieldset>
  {/each}
  <div class:explanation={negative}>
    <label for="completion-comment">{negative ? 'Sorry about that. What went wrong? *' : 'Comment (optional)'}</label>
    {#if negative}<p>Our customer care team will call you today.</p>{/if}
    <textarea id="completion-comment" bind:value={comment} required={negative} maxlength="2000" rows="3"></textarea>
  </div>
</div>
<style>
  .scores { display: grid; gap: 24px; font-size: 16px; color: #10243b; }
  fieldset { min-width: 0; padding: 0; border: 0; }
  legend, label[for] { font-weight: 650; margin-bottom: 12px; display: block; }
  .scale { display: flex; gap: 8px; }
  .scale label { position: relative; flex: 1; min-width: 0; cursor: pointer; }
  .scale input { position: absolute; opacity: 0; width: 100%; height: 100%; margin: 0; }
  .scale span { display: flex; align-items: center; justify-content: center; min-height: 52px; border: 1px solid #aeb6ba; border-radius: 12px; font-size: 20px; font-weight: 650; }
  input:checked + span { background: #206b76; color: white; border-color: #206b76; }
  .negative input:checked + span { background: #9b3c11; border-color: #9b3c11; }
  input:focus-visible + span { outline: 3px solid #10243b; outline-offset: 3px; }
  .anchors { display: flex; justify-content: space-between; gap: 8px; color: #535b60; font-size: 15px; margin-top: 6px; }
  .anchors span:last-child { text-align: right; }
  .explanation { padding: 16px; background: #fff3e9; border: 1px solid #ecc2a6; border-radius: 12px; }
  p { margin: 0 0 12px; }
  textarea { width: 100%; min-height: 90px; font: inherit; padding: 12px; border: 1px solid #aeb6ba; border-radius: 12px; background: white; }
  button { min-height: 52px; font: inherit; color: #206b76; text-decoration: underline; }
</style>
